module.exports = __webpack_public_path__ + "img/warning.fd9b6fad.svg";